/*
 * Purpose : Display Help Document
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, {useEffect, useState} from 'react';
import Iframe from 'react-iframe'

import Aux from '../../hoc/Auxilliary/Auxilliary';
import LoadingModal from '../UI/modals/loadingModal';

import { Storage } from 'aws-amplify';

const helpFilePath = process.env.REACT_APP_HELP_DOC;

const Help = (props) => {
    const [loading, setLoading] = useState(false)
    const[url, setUrl] = useState(null)

    useEffect(() => {
        const a = async() => {            
            setLoading(true)
            await Storage.get(helpFilePath).then(path=>{
                setUrl(path+'#view=Fit')
                //setUrl(path)
                setLoading(false)
            } )
        }
        a()               
    }, [])

    return(
        <Aux>
            <div style={{margin:"-1% 1% 0% 2%"}}>
                <LoadingModal open={loading} msg="Loading..." />
                <Iframe url={url}
                    width="100%"
                    height="550px"
                />
            </div>            
        </Aux>
    )
}
export default Help;